import { apiWithAuth } from "@/lib/axios";
import type { Skill } from "./types";
import { emitCopilotMutation } from "../mutations";
import { withFollow } from "./followHelpers";

export const setProductStockSkill: Skill = {
  id: "setProductStock",
  description:
    "Ajusta el stock visible de un producto. Si trackStock está activo, pone el contador en el valor exacto.",
  schema: {
    type: "object",
    properties: {
      restaurantId: { type: "string" },
      productId: { type: "string" },
      stock: { type: "number" },
      trackStock: { type: "boolean" },
    },
    required: ["restaurantId", "productId"],
  },
  async run(args, ctx) {
    if (!ctx.accessToken) return { ok: false, error: "Sesión no disponible." };
    const restaurantId = String(args.restaurantId ?? "");
    const productId = String(args.productId ?? "");
    if (!restaurantId || !productId) return { ok: false, error: "Faltan IDs." };
    const patch: Record<string, unknown> = {};
    const details: Array<{ label: string; value: string }> = [];
    if (Number.isFinite(Number(args.stock)) && Number(args.stock) >= 0) {
      patch.stock = Number(args.stock);
      details.push({ label: "Stock", value: `${patch.stock} unidad(es)` });
    }
    if (typeof args.trackStock === "boolean") {
      patch.trackStock = args.trackStock;
      details.push({
        label: "Tracking automático",
        value: args.trackStock ? "Activado" : "Desactivado",
      });
    }
    if (Object.keys(patch).length === 0) return { ok: false, error: "Nada que actualizar." };

    const ok = await ctx.confirmation.confirm({
      title: "Ajustar stock",
      details,
      confirmLabel: "Aplicar",
    });
    if (!ok) return { ok: false, error: "Acción cancelada por el usuario." };

    return withFollow(ctx, {
      intro: "Actualizando stock…",
      successMsg: "✓ Stock actualizado",
      restaurantId,
      targetTab: "productos",
      targetTabLabel: "Productos",
      run: async () => {
        try {
          await apiWithAuth.patch(
            `/restaurants/${restaurantId}/products/${productId}`,
            patch,
            ctx.accessToken,
          );
          emitCopilotMutation({
            scope: "products",
            action: "updated",
            restaurantId,
            id: productId,
          });
          return {
            ok: true as const,
            result: { productId, ...patch },
            humanSummary: "Stock actualizado.",
          };
        } catch (err: any) {
          return { ok: false as const, error: err?.response?.data?.message ?? "Error." };
        }
      },
    });
  },
};
